module.exports = __webpack_public_path__ + "static/media/button-arrow-right.f8f2a0bc.svg";